import { useMemo } from 'react'

import { SimpleGrid, Stack, Title } from '@mantine/core'
import { useTranslate } from 'react-admin'
import { PermissionApiDTO } from '../../../codegen/generated/Api.schemas'
import { LXCard } from '../../../components/LXCards/LXCard'
import { UsersHelper } from '../../../helpers/Users.helper'

type RolePermissionCardsProps = {
  availableRoles?: PermissionApiDTO[]
  readonly?: boolean
}

export const RolePermissionCards = ({
  availableRoles = [],
  readonly = false,
}: RolePermissionCardsProps) => {
  const t = useTranslate()

  const rolesPermissions = useMemo(
    () =>
      UsersHelper.ROLES_PERMISSIONS.map(rp => ({
        group: t(`pages.users.rolesPermissionsGroups.${rp.group}`),
        items: rp.items
          .map(item => ({
            value: item,
            label: t(`pages.users.rolesPermissions.${item}.title`),
            description: t(`pages.users.rolesPermissions.${item}.description`),
          }))
          .filter(item => (availableRoles.length > 0 ? availableRoles.includes(item.value) : true)),
      })),
    [t, availableRoles],
  )

  return (
    <SimpleGrid cols={3} spacing="md" verticalSpacing="xl" w="100%" pt="md">
      {rolesPermissions.map(rp => {
        if (rp.items.length > 0) {
          return (
            <Stack key={rp.items[0]?.value ?? ''}>
              <Title order={6}>{rp.group}</Title>
              <Stack>
                {rp.items.map(item => (
                  <LXCard<PermissionApiDTO> key={item.value} roleItem={item} readonly={readonly} />
                ))}
              </Stack>
            </Stack>
          )
        }

        return undefined
      })}
    </SimpleGrid>
  )
}
